export const IMPORT_PROCESS_REQUESTED = 'IMPORT_PROCESS_REQUESTED';
/**
 * @param {import("../../components/csv-import/data/types/types").RequestImportActionPayload} payload
 * @returns {void}
 */
export const importProcessRequested = (payload) => ({
  type: IMPORT_PROCESS_REQUESTED,
  payload,
});

export const UPDATE_IMPORT_STATUS = 'UPDATE_IMPORT_STATUS';
export const updateImportStatus = (payload) => ({
  type: UPDATE_IMPORT_STATUS,
  payload,
});

export const ADD_METADATA_TO_IMPORT = 'ADD_METADATA_TO_IMPORT';
/**
 * @param {{importType: import("../../components/csv-import/data/types/import-type").ImportTypes, metadata: {}}} payload
 * @returns {void}
 */
export const addMetadataToImport = (payload) => ({
  type: ADD_METADATA_TO_IMPORT,
  payload,
});

export const CLEAR_IMPORT_STATUS = 'CLEAR_IMPORT_STATUS';
/**
 * Clears the import status for a specific import type
 * @param {import("../../components/csv-import/data/types/import-type").ImportTypes} importType
 * @returns {void}
 */
export const clearImportStatus = (importType) => ({
  type: CLEAR_IMPORT_STATUS,
  payload: { importType },
});
